// hooks/useCategoriesCache.js
import { useEffect } from "react";

export const useCategoriesCache = (categories) => {
  useEffect(() => {
    if (categories && categories.length > 0) {
      // Armazena as categorias no localStorage
      const cacheData = categories.map((cat) => ({
        id: cat.id,
        name: cat.name,
        url: cat.url,
        formattedUrl: cat.url
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/\//g, "")
          .toLowerCase(),
      }));

      sessionStorage.setItem("categoriesCache", JSON.stringify(cacheData));
    }
  }, [categories]);
};

// Hook para acessar o cache
export const useGetCachedCategories = () => {
  const getCache = () => {
    const cache = localStorage.getItem("categoriesCache");
    return cache ? JSON.parse(cache) : null;
  };

  return { getCachedCategories: getCache };
};
